export default {
  name: 'ProfileInfoModalComponent',
  props:{
    //- 是否顯示禮物兌換紀錄
    isProfileInfoModalShow: {
      type: Boolean,
      required: true
    },
    //- 會員基本資料
    memberProfile: {
      type: Object,
      default: null,
    }
  },
  data(){
    return {
      profileInfo: {
        name: '小白兔',
        bank: '台北富邦商業銀行',
        branch: '敦南',
        ic: '洪大熊'
      }
    }
  },
  methods:{
    //- 關閉
    closeHandler: function () {
      let vm = this;
      vm.resetHandler();
      //- 呼叫父元件
      vm.$emit('closeHandler');
    },
    //- 初始化
    resetHandler: function () {
      let vm = this;
    },
    updateMember() {
      window.location.href = process.env.VUE_APP_UPDATE_MEMBER_INFO_URL
    }
  },
}
